var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-con-loading__container",attrs:{"id":_vm.loadingPage}},[_c('div',{staticClass:"flex mb-4"},[_c('div',{staticClass:"w-full"},[_c('vs-card',[_c('repse-request-table',{attrs:{"data":_vm.data,"title":'REPSE - Solicitudes'},on:{"back":_vm.back,"loadMore":_vm.loadMore,"search":_vm.search,"refresh":_vm.getData}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }